import {
  Button,
  Spacer,
  Split,
  SplitSection,
  Text,
  TextInput,
} from '@loomhq/lens';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeModal } from 'actions/modals';
import { CREATION_METHOD_ANON_RECORD_REPLY } from 'constants/comments';
import { ANON_COMMENT_BUTTON_CLICKED } from 'constants/events';
import { ANON_RECORD_A_REPLY } from 'constants/onboarding';
import { addCommentCreator } from 'creators/commentsGraphQl';
import { selectPlayerTime } from 'selectors/videoPlayer';
import * as analytics from 'utilities/analytics';
import { incrementMetric } from 'utilities/metrics';
import { secondsToVideoTS } from 'utilities/time';

import styles from './styles.module.less';

const AnonCommentFooter = ({ isFooter }) => {
  const [anonUserName, setAnonUserName] = useState('');

  const dispatch = useDispatch();
  const addReplyId = useSelector(state => state.modals?.options?.addReplyId);
  const comment = useSelector(state => state.modals?.options?.comment);
  const videoCurrentTime = useSelector(selectPlayerTime);

  const videoTS = `${secondsToVideoTS(Math.round(videoCurrentTime))}`;

  const onCommentHandler = () => {
    analytics.track(ANON_COMMENT_BUTTON_CLICKED, {
      source: ANON_RECORD_A_REPLY,
    });
    incrementMetric('button.click', {
      context: ANON_COMMENT_BUTTON_CLICKED,
      source: ANON_RECORD_A_REPLY,
    });

    dispatch(
      addCommentCreator({
        comment,
        addReplyId,
        anonUserName,
        creationMethod: CREATION_METHOD_ANON_RECORD_REPLY,
      })
    );

    dispatch(closeModal());
  };

  return (
    <>
      {isFooter && (
        <div className={styles.anonCommentFooter}>
          <Spacer bottom="small" top="0.75rem" x="2.5rem">
            <Text color="bodyDimmed" fontWeight="medium" alignment="left">
              Post without an account
            </Text>
          </Spacer>
        </div>
      )}

      <Text size="small" fontWeight="medium" color="grey8">
        Your name
      </Text>
      <Split width="100%">
        <SplitSection grow={1}>
          <TextInput
            value={anonUserName}
            onChange={e => setAnonUserName(e.target.value)}
          />
        </SplitSection>

        <SplitSection>
          <Spacer left={1} />
        </SplitSection>

        <SplitSection>
          <Button
            disabled={!anonUserName}
            variant="primary"
            onClick={onCommentHandler}
          >
            Comment at {videoTS}
          </Button>
        </SplitSection>
      </Split>
    </>
  );
};

export default AnonCommentFooter;
